import script from "./charge_publish.vue?vue&type=script&setup=true&lang=js"
export * from "./charge_publish.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__